import { nanoid } from "nanoid";


export default function useAppID() {
    const cacheKey = 'APP_ID';
    const ls = window.localStorage || localStorage;

    let APP_ID = ls.getItem(cacheKey);
    if (!APP_ID || APP_ID.length < 1) {
        ls.setItem(cacheKey, nanoid(20))
        APP_ID = ls.getItem(cacheKey);
    }

    return APP_ID
}